import * as z from "zod";

export const setCustomDomainMailFromDomain = {
  name: "setCustomDomainMailFromDomain" as const,
  input: z.object({ domain: z.string().nullish(), mailFromDomain: z.string() }),
  output: z.null(),
};
